export default {
    name: 'Thursday',
    logoVariant: 'dark',
    logo: {
        square: '/src/brands/thursday/assets/square.png',
    },
    pwa: {
        name: 'Thursday Resort Management',
        shortName: 'Thursday',
        themeColor: '#FBD3EB',
        backgroundColor: '#ffffff',
        icon: '/src/brands/thursday/assets/icon.png',
        vapidPublicKey: 'BO6LHTcktRG1xwi5WAKtKKzmOy-Y4v1rr0Etqw8gXY5vYolkQATa1iHs_pq44R8XVOGm1UaI-lurI_ggeZQxv2E'
    }
}
